import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Button, Modal } from 'react-bootstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/fontawesome-free-solid';

const modalRoot = document.getElementById("modal-root");

export default class ApiErrorModal extends Component {

    constructor(props) {
        super(props);
        this.el = document.createElement("div");
    }

    componentDidMount() {
        modalRoot.appendChild(this.el);
    }

    componentWillUnmount() {
        modalRoot.removeChild(this.el);
    }

    render() {
        return ReactDOM.createPortal(
            <div>
                <Modal className="error-modal"
                    show={true}
                    onHide={this.props.handleHideModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <FontAwesomeIcon size='1x' icon={faExclamationCircle} />
                            {" API Error"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <section>
                            <h3>Error</h3>
                            <p>{this.props.modalErrorMessage}</p>
                        </section>
                        <section>
                            <h3>StatusCode</h3>
                            <p>{this.props.modalStatusCode}</p>
                        </section>
                        <section>
                            <h3>API</h3>
                            <p>{this.props.modalApiPath}</p>
                        </section>
                        <section>
                            <h3>ResponseMessage</h3>
                            <p>{this.props.modalApiMessage}</p>
                        </section>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.props.handleHideModal}>OK</Button>
                    </Modal.Footer>
                </Modal>
            </div >,
            this.el
        );
    }
}


// WEBPACK FOOTER //
// ./src/js/ApiErrorModal.js